var map = {
	"./GPay.svg": 3890,
	"./amex.svg": 2399,
	"./applePay_logo.svg": 8654,
	"./diners.svg": 1724,
	"./discover.svg": 2197,
	"./generic_payment.svg": 6360,
	"./mastercard.svg": 4954,
	"./visa.svg": 8634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5406;